import apolloUtil from '@/service/ApolloUtil'

import receiptsQuery from './ReceiptsQuery.gql'
import receiptQuery from './ReceiptQuery.gql'
import updateProcessMutation from './ProcessedFlagMutation.gql'

class ReceiptsService {

  search(params) {
    return apolloUtil.query(receiptsQuery, params)
      .then((response) => response?.data?.receipts)
  }

  getById(params) {
   return apolloUtil.query(receiptQuery, params)
     .then((response) => response?.data?.getReceipt)
  }

  process(params) {
    return apolloUtil.mutate(updateProcessMutation, params)
  }

}

export default new ReceiptsService()
